import { memo, useEffect } from 'react';
import Animated, {
  useAnimatedStyle,
  useSharedValue,
  withRepeat,
  withTiming,
} from 'react-native-reanimated';
import { SkeletonProps } from './Skeleton.types';
import useStyle from '../../hooks/useStyle';
import {
  SKELETON_DEFAULT_STYLES,
  SKELETON_TIMING_CONFIG,
} from './Skeleton.content';

function Skeleton(props: SkeletonProps) {
  const style = useStyle({ ...SKELETON_DEFAULT_STYLES, ...props });
  const sharedValue = useSharedValue(1);
  const animatedStyle = useAnimatedStyle(() => ({
    opacity: sharedValue.value,
  }));

  useEffect(() => {
    sharedValue.value = withRepeat(
      withTiming(0.4, SKELETON_TIMING_CONFIG),
      -1,
      true,
    );
  }, [sharedValue]);

  return <Animated.View style={[style, animatedStyle]} />;
}

export default memo(Skeleton);
